/**
 * Created by Administrador on 29/12/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('taxesCtrl', taxesCtrl)
        .controller('newEditTaxController', newEditTaxController)
        .controller('modalApplyCountryAirportController', modalApplyCountryAirportController)
        .controller('deleteTaxController', deleteTaxController);

    taxesCtrl.$inject = ['linkService','taxes'];
    newEditTaxController.$inject = ['linkService','$uibModal','passengerTypeService','$translate','calculationTypes',
        'flightTypeTaxService','taxService','tax','currencies'];
    deleteTaxController.$inject = ['taxId', 'tax', 'taxService', '$uibModalInstance'];

    function taxesCtrl(linkService,taxes){
        var vm = this;
        vm.linkService = linkService;

        vm.taxes = (taxes.data._embedded) ? taxes.data._embedded.taxes : [];
        vm.pages = taxes.data.page;
    };

    function newEditTaxController(linkService,$uibModal,passengerTypeService,$translate,calculationTypes,
                                  flightTypeTaxService,taxService,tax,currencies){
        var vm = this;
        vm.linkService = linkService;

        vm.tax = {};
        vm.tax.flightTypes = [];
        vm.tax.countryAirports = [];
        vm.tax.active = false;
        vm.tax.fiscalCredit = false;

        var urlTemplateBase = "app/admin/configGeneral/rates/tax/templates/";
        vm.taxTemplates = [
            {
                name: "flightType",
                template: urlTemplateBase + "flightTypeTax/flightTypeTax.html"
            },
            {
                name: "countryAirport",
                template: urlTemplateBase + "countryAirportTax/countryAirportTax.html"
            },
            {
                name: "passengerType",
                template: urlTemplateBase + "passengerTypeTax/passengerTypeTax.html"
            }
         ];

        /* flight type {*/
        vm.calcTypes = calculationTypes.data._embedded.calculationTypes;
        vm.checkBoxFlightType = {};
        vm.currencies = currencies;
        for (var i = 0; i < vm.currencies.length; i++){
            vm.currencies[i].currencyId = parseInt(linkService.getLinkId(vm.currencies[i]._links.self.href));
        }

        vm.getFlightTypes = function(flightTypeTaxes){
            flightTypeTaxService.getFlightTypeTax()
                .then(function(response){
                    var flightTypeTaxTypes = (response.data._embedded) ? response.data._embedded.flightTypeTaxTypes : [];
                    angular.forEach(flightTypeTaxTypes, function(flightTypeTaxType){

                        var flightTypeTax = {};
                        if(flightTypeTaxes.length > 0){
                            flightTypeTax = getFlightTypeTax(flightTypeTaxes, flightTypeTaxType);
                        }
                        vm.tax.flightTypes.push({
                            code: flightTypeTaxType.code,
                            type: flightTypeTaxType.lang,
                            calculationType: (flightTypeTax._embedded) ? flightTypeTax._embedded.calculationType.code: "",
                            amount: (flightTypeTax.amount) ? flightTypeTax.amount : '',
                            currencyId: (flightTypeTax.currencyId) ? flightTypeTax.currencyId : "",
                            select: (flightTypeTax._embedded) ? true: false,
                            flightTypeTaxId: (flightTypeTax._embedded) ? linkService.getLinkId(flightTypeTax._links.self.href): 0
                        });
                        vm.checkBoxFlightType[flightTypeTaxType.code] = (flightTypeTax._embedded) ? true: false;
                    });
                });
        }

        vm.eventHandleFlightType = function(){
            var j = 0;
            angular.forEach(vm.checkBoxFlightType, function (i, val) {
                if(i == false || i == undefined){
                    vm.tax.flightTypes[j].select = false;
                }else if (i == true){
                    vm.tax.flightTypes[j].select = true
                }
                j++;
            });
        }

        vm.handleChangeCalcType = function(index){
            vm.tax.flightTypes[index].currencyId = "";
        }

        function getFlightTypeTax(flightTypeTaxes, flightTypeTaxType){
            var res = {};
            for(var i = 0; i < flightTypeTaxes.length; i++){
                if(flightTypeTaxType.code == flightTypeTaxes[i]._embedded.flightTypeTaxType.code){
                    res = flightTypeTaxes[i];
                    break;
                }
            }
            return res;
        }
        /* flight type }*/

        /* country & airport {*/
        vm.getCountryAirports = function(countryAirports){
            var res = [];
            angular.forEach(countryAirports, function (countryAirport) {
                res.push({
                    departure: countryAirport.departure,
                    arrival: countryAirport.arrival,
                    //countryId: 0,
                    //airportId: 0,
                    countryId: countryAirport.countryId,
                    airportId: countryAirport.airportId,
                    type: countryAirport.type,
                    _embedded: countryAirport._embedded
                });
            });
            return res;
        }

        vm.addApplyCountryAirport = function(type){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/tax/templates/countryAirportTax/modalApplyCountryAirport.html',
                controller: 'modalApplyCountryAirportController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    type: [function() {
                        return type
                    }],
                    countries: ['countryService', function(countryService){
                        return countryService.getActiveCountries(true,false);
                    }]
                }
            }).result.then(function(response) {
                angular.forEach(response.countryAirport, function (res) {
                    vm.tax.countryAirports.push(res);
                 });
            }, function() {
                //$state.go('^');
            });
        }

        vm.deleteCountryAirport = function(index){
            vm.tax.countryAirports.splice(index, 1);
        }
        /* country & airport }*/

        /* passenger type {*/
        vm.treeInstance = {};

        vm.getPassengerTypes = function(passengerTypeTaxes){
            passengerTypeService.getPassengerTypes()
                .then(function(response){
                    var passengerTypes = (response.data._embedded) ? response.data._embedded.passengerTypes : [];
                    vm.idsPassenger = (passengerTypeTaxes != null) ? idsPassenger(passengerTypeTaxes) : [];
                    vm.tax.passengerTypesTree = refactorJson(passengerTypes, vm.idsPassenger, $translate, linkService);
                    vm.treeConfig = getTreeConfig();
                });
        }

        function idsPassenger(passengerTypeTaxes){
            var ids = [];
            angular.forEach(passengerTypeTaxes, function(passengerTypeTax){
                ids.push(passengerTypeTax.passengerTypeId+"");
            });
            return ids;
        }

        /* passenger type }*/

        function loadObject(tax){
            if(tax != null){
                vm.action = 'edit';
                vm.tax.code = tax.data.code;
                vm.tax.name = tax.data.name;
                vm.tax.nameLang = tax.data.nameLang;
                vm.tax.description = tax.data.description;
                vm.tax.fiscalCredit = tax.data.fiscalCredit;
                vm.tax.active = tax.data.active;
                vm.tax.taxId = vm.linkService.getLinkId(tax.data._links.self.href);

                vm.getFlightTypes(tax.data._embedded.flightTypeTaxes);
                vm.tax.countryAirports = vm.getCountryAirports(tax.data._embedded.countryAirportTaxes);
                vm.getPassengerTypes(tax.data._embedded.passengerTypeTaxes);

            }else{
                vm.action = 'new';
                vm.getFlightTypes([]);
                vm.getPassengerTypes(null);
            }
        }

        vm.saveTax = function(isValid, tax){
            if(isValid){
                var selected_nodes = vm.treeInstance.jstree(true).get_selected();
                vm.tax.rbcPassengerTypeTaxes = getPassengerTypeIds(selected_nodes);
                vm.tax.rbcCountryAirportTaxes = vm.tax.countryAirports;
                vm.tax.rbcFlightTypeTaxes = getFlightTypesData(vm.tax.flightTypes)
                if(vm.action == "new"){
                    taxService.saveTax(vm.tax);
                }else{
                    taxService.updateTax(vm.tax.taxId, vm.tax);
                }
            }
        }

        loadObject(tax);

    }

    function modalApplyCountryAirportController($uibModalInstance, type, routeService, flightService, linkService,countryService,airportService){
        var vm = this;
        vm.linkService = linkService;

        vm.countries = [];
        vm.airports = [];
        vm.countriesCheckBox = {};
        vm.airportsCheckBox = {};
        vm.countrySelected = "";
        vm.countryAirport = {
            type: "COUNTRY",
            departure: false,
            arrival: false
        }

        vm.routeIds = [];
        vm.routesSelect = [];
        vm.routeId = "";

        vm.eventChangeOption = function(type){
            if(type == "COUNTRY"){
                vm.getCountriesCheckBox();
            }
        }

        vm.getCountriesCheckBox = function(){
            countryService.getActiveCountries(true,false)
                .then(function(response){
                    vm.countries = response;
                    angular.forEach(vm.countries, function(country){
                        vm.countriesCheckBox[vm.linkService.getLinkId(country._links.self.href)] = false;
                    });
                })
        }

        vm.getAirports = function(country){
            if(country != undefined) {
                airportService.getAirportsByCountry(vm.linkService.getLinkId(country._links.self.href))
                    .then(function (response) {
                        vm.airports = (response.data._embedded) ? response.data._embedded.airports : [];
                        angular.forEach(vm.airports, function (airport) {
                            vm.airportsCheckBox[vm.linkService.getLinkId(airport._links.self.href)] = false;
                        });
                    })
            }else{
                vm.airports = [];
            }
        }

        vm.addCountryAirport = function(isValid, countryAirport){
            if(isValid){
                if(countryAirport.departure || countryAirport.arrival){
                    var resModal;
                    if(vm.countryAirport.type == "COUNTRY"){
                        var dataCountries = [];
                        angular.forEach(vm.countries, function(country){
                            var countryId = vm.linkService.getLinkId(country._links.self.href);
                            if(vm.countriesCheckBox[countryId] == true){
                                dataCountries.push({
                                    application: type,
                                    departure: countryAirport.departure,
                                    arrival: countryAirport.arrival,
                                    countryId: parseInt(countryId),
                                    airportId: 0,
                                    type: countryAirport.type,
                                    _embedded: {
                                        country: country
                                    }
                                });
                            }
                        });
                        resModal = dataCountries;
                    }else{
                        var dataAirports = [];
                        angular.forEach(vm.airports, function(airport){
                            var airportId = vm.linkService.getLinkId(airport._links.self.href);
                            if(vm.airportsCheckBox[airportId] == true){
                                dataAirports.push({
                                    application: type,
                                    departure: countryAirport.departure,
                                    arrival: countryAirport.arrival,
                                    countryId: 0,
                                    airportId: parseInt(airportId),
                                    type: countryAirport.type,
                                    _embedded: {
                                        airport: airport
                                    }
                                });
                            }
                        });
                        resModal = dataAirports;
                    }
                    $uibModalInstance.close({countryAirport: resModal, type: countryAirport.type});
                }
            }
        }

        vm.addApplyToNoApply = function(route, id){
            if(vm.routesCheckBox[id] == true){
                vm.routeIds.push(id)
                /*vm.routesSelect.push({
                 route:
                 })*/
            }else if(vm.routesCheckBox[id] == false || vm.routesCheckBox[id] == undefined){
                var pos = vm.routeIds.indexOf(id);
                vm.routeIds.splice(pos, 1);
            }

            for(var i = 0; i < vm.routeIds.length; i++){
                if(i == 0){
                    vm.routeId = vm.routeIds[i];
                }else{
                    vm.routeId = vm.routeId + "," + vm.routeIds[i];
                }
            }
            vm.flightRoute.routeId  = vm.routeId;
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.getCountriesCheckBox();
    }

    function deleteTaxController(taxId, tax, taxService, $uibModalInstance) {
        var vm = this;

        vm.name = tax.data.name;

        vm.deleteTax = function () {
            taxService.deleteTax(taxId)
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function refactorJson(passengerTypes, idsPassenger, $translate, linkService){
        var data = [];

        data.push({"id": 2000, "parent": "#", "text": $translate.instant("air.passengerType.adults"), "state": { "opened": true }});
        data.push({"id": 2001, "parent": "#", "text": $translate.instant("air.passengerType.infants"), "state": { "opened": true }});

        angular.forEach(passengerTypes, function(passengerType){
            var parent = 0;
            if(passengerType.group == "adult"){
                parent = 2000;
            }else{
                parent = 2001;
            }

            var stateData = { "opened": true };

            if(idsPassenger.length > 0){
                if(idsPassenger.indexOf(linkService.getLinkId(passengerType._links.self.href)) != -1){
                    stateData = {"opened": true, "selected" : true};
                }
            }

            data.push({
                "id": linkService.getLinkId(passengerType._links.self.href),
                "parent": parent,
                "text": $translate.instant(passengerType.lang),
                "state": stateData
            });
        });
        return data;
    }

    function getTreeConfig(){
        return {
            core : {
                multiple : true,
                animation: true,
                error : function(error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback : true,
                worker : true,
                themes: {
                    "icons": false
                }
            },
            plugins : ['checkbox']
        }
    }

    function getPassengerTypeIds(dataIds){
        var res = [];
        for(var i = 0; i < dataIds.length; i++){
            if(dataIds[i] != "2000" && dataIds[i] != "2001"){
                res.push({
                    "passengerTypeId": parseInt(dataIds[i])
                });
            }
        }
        return res;
    }

    function getFlightTypesData(flightTypes){
        var res = [];
        angular.forEach(flightTypes, function (flightType) {
            if (flightType.select == true) {
                res.push({
                    type: flightType.code,
                    calculationType: flightType.calculationType,
                    amount: flightType.amount,
                    currencyId: flightType.currencyId
                });
            }
        })
        return res;
    }
})();
